import type { UAPStyleMap } from '../../@types';

export const getImageExtensionPlacementBaseStyles = (_theme?: object): UAPStyleMap => ({
  placementCard: {
    borderRadius: '0 !important',
  },

  placementImageContainer: undefined,

  placementTextContainer: undefined,

  placementAdsLabel: undefined,

  placementGradient: undefined,

  placementShortHeadline: undefined,

  placementLongHeadline: undefined,

  placementFinalUrl: undefined,

  placementDescription: undefined,

  placementCallToAction: undefined,

  placementBusinessNameWithAdsLabel: undefined,
});


export const getImgExtWideImage191x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    height: 364,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    borderRadius: '0 !important',
  },

  placementTextContainer: {
    padding: 10,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
    maxWidth: '-webkit-fill-available',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 18,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },
});


export const getImgExtMSEdgeSingleCarousel178x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    '&:hover $placementGradient': {
      height: '480px !important',
      top: -100,
    },
    borderRadius: '0 !important',
    width: '624px !important',
  },

  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
    fontSize: 10,
    lineHeight: '16px',
    color: '#bebebe',
  },

  placementGradient: {
    display: 'block',
    width: '100%',
    height: '280px !important',
    top: 100,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementShortHeadline: {
    fontWeight: '200',
    fontSize: 28,
    lineHeight: '33.99px',
    color: 'white',
    width: 590,
    height: 73,
    marginBottom: 20,

    '& .multi-line-processed-text': {
      position: 'absolute',
      bottom: 30,
    },
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      color: '#fff !important',
      opacity: 0.7,
      border: '.5px solid hsla(0,0%,100%,.3) !important',
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },
});


export const getImgExtBingDesktopSingleImage178x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    width: '608px !important',
    height: 110,
    border: '0.5px solid #ddd',
    padding: 0,
    borderRadius: '0 !important',
  },

  placementImageContainer: {
    float: 'right',
    width: 100,
    margin: 8,
    transform: 'translate(20px,20px)',
  },

  placementTextContainer: {
    margin: '4px 8px 0px 8px',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementLongHeadline: {
    color: '#0078d4',
    height: 28,
    overflow: 'hidden',
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
  },

  placementFinalUrl: {
    color: '#0b6a0b',
    height: 20,
    overflow: 'hidden',
    fontSize: 14,
  },

  placementDescription: {
    color: '#333',
    fontSize: 13,
    minHeight: 18,
  },
});


export const getImgExtMSEdgeMediumHeadline172x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    width: '300px !important',
    height: 250,
    backgroundColor: 'rgb(46, 46, 46) !important',
    borderRadius: '0 !important',
    overflow: 'hidden',
    position: 'relative',

    '&:hover $placementGradient': {
      height: '480px !important',
      top: -172,
    },
  },

  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
  },

  placementLongHeadline: {
    fontSize: 10,
    lineHeight: '16px !important',
    color: '#bebebe !important',
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      border: '.5px solid hsla(0,0%,100%,.3) !important',
      color: '#fff !important',
      opacity: 0.7,
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },

  placementGradient: {
    position: 'relative',
    height: '280px !important',
    marginTop: -105,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, rgb(46, 46, 46) 100%)',
  },
});


export const getImgExtMSNSingleCarousel169x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    '&:hover $placementGradient': {
      height: '480px !important',
      top: -80,
    },

    width: '622px !important',
    height: 368,
    borderRadius: '0 !important',
  },

  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
    fontSize: 10,
    lineHeight: '16px',
    color: '#bebebe',
  },

  placementGradient: {
    display: 'block',
    width: '100%',
    height: '280px !important',
    top: 120,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementLongHeadline: {
    fontWeight: '200',
    fontSize: 28,
    lineHeight: '33.99px',
    color: 'white',
    width: 590,
    height: 73,
    marginBottom: 20,

    '& .multi-line-processed-text': {
      position: 'absolute',
      bottom: 30,
    },
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      color: '#fff !important',
      opacity: 0.7,
      border: '.5px solid hsla(0,0%,100%,.3) !important',
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },
});


export const getImgExtMSNMediumHeadline155x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    display: 'block',
    position: 'relative',
    overflow: 'hidden',
    width: '300px !important',
    height: 296,
    margin: 'auto',
    padding: 0,
    borderRadius: '0 !important',
    borderWidth: 'thin',
    color: '#ddd',
    border: 'solid',
  },

  placementTextContainer: {
    height: 98,
    padding: '15px 13px',
    color: '#333',
    fontSize: 10,
    lineHeight: '16px !important',
  },
});


export const getImgExtMSNInArticle150x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    borderRadius: '0 !important',
    height: 364,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
  },

  placementTextContainer: {
    padding: 10,
    height: 98,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },
});


export const getImgExtMSNSmallHeadline133x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    borderRadius: '0 !important',
    width: '300px !important',
    height: 90,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
  },

  placementImageContainer: {
    float: 'left',
    width: 100,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 52,
    margin: '4px 8px 0 8px',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },
});


export const getImgExtBingDesktopMultiImage133x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    borderRadius: '0 !important',
    width: '548px !important',
    height: 242,
    color: '#333',
    border: '0.5px solid #ddd',
    boxShadow: 'none !important',
    padding: 10,
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },

  placementTextContainer: {
    position: 'relative',
    top: -1,
    width: '100% !important',
  },

  placementLongHeadline: {
    color: '#003DC1',
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '27px',
  },

  placementFinalUrl: {
    position: 'relative',
    top: -1,
    color: '#0b6a0b',
    fontSize: 12,
    lineHeight: '16px',
  },

  placementDescription: {
    position: 'relative',
    top: -1,
    color: '#333',
    fontSize: 12,
    lineHeight: '16px',
    margin: '2px 0px 7px 0px',
  },

  placementImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    left: -4,
    top: 3,

    '& .bing-desktop-multi-image-item': {
      width: 130,
      height: 135,
      border: '0.5px solid #ddd',
      overflow: 'hidden',
      marginRight: 5,
      borderRadius: 6,
    },
  },
});


export const getImgExtBingMobileMultiImage133x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    display: 'block !important',
    borderRadius: '6px !important',
    color: '#333',
    border: '0.5px solid #ddd',
    boxShadow: 'none !important',
  },

  placementAdsLabel: {
    // position: absolute;
    top: 10,
    left: 5,
    color: '#fff !important',
    border: '1px solid #ddd !important',
    padding: '5px 1px 7px 1px !important',
    lineHeight: '0.1em',
    borderRadius: '6px !important',
    backgroundColor: '#666 !important',
    margin: '0 !important',
    fontSize: '14px !important',
    opacity: '1 !important',
  },

  placementTextContainer: {
    position: 'relative',
    width: '400px !important',
    height: 118,
    padding: 10,
    lineHeight: '16px',
  },

  placementLongHeadline: {
    color: '#003DC1',
    height: 24,
    fontSize: 18,
    fontWeight: 400,
  },

  placementFinalUrl: {
    color: '#0b6a0b',
    height: 20,
    fontSize: 14,
    fontWeight: 400,
    borderBottom: '1px solid #ddd',
    marginBottom: 6,
    paddingBottom: 6,
  },

  placementDescription: {
    height: 40,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    margin: '2px 0px 7px 0px',
  },

  placementImageContainer: {
    '& .multi-image-placement-carousel': {
      '& .carousel-inner': {
        paddingBottom: '0px !important',
      },
      '& .carousel-indicators': {
        position: 'absolute',
        left: 0,
        width: 'auto',
        bottom: 0,
        margin: '20px 24px',

        '& li': {
          width: 10,
          height: 10,
          border: '1px solid #605E5C',
          margin: '0 10px 0 0',
          background: 'rgba(255, 255, 255, 0.8)',
          borderRadius: 10,

          '&.active': {
            border: '1px solid #0078d4',
            background: '#0078d4',
          },
        },
      },

      '& .carousel-control': {
        position: 'absolute',
        top: 'auto',
        left: 'auto',
        right: 0,
        bottom: 0,
        width: 16,
        height: 32,
        margin: '20px 24px',
        paddingRight: 4,
        color: '#0078d4',
        background: 'rgba(255, 255, 255, 0.6)',
        textShadow: 'none',

        '&.left': {
          marginRight: 76,
        },

        '& .glyphicon.glyphicon-chevron-left, & .glyphicon.glyphicon-chevron-right': {
          fontSize: 16,
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          margin: 0,
          position: 'relative',
          lineHeight: 1,
          verticalAlign: 0,
        },
      },
    },
  },
});


export const getImgExtSquareImage1x1Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    borderRadius: '0 !important',
    width: '300px !important',
    height: 90,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
  },

  placementImageContainer: {
    float: 'left',
    width: 80,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 45,
    margin: '8px 8px 0 8px',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },
});


export const getImgExtMSNDoubleCarousel93x100Styles = (theme: object) => ({
  // base styles

  ...getImageExtensionPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    '&:hover $placementGradient': {
      height: '480px !important',
      top: -118,
    },

    width: '310px !important',
    height: 333,
    borderRadius: '0 !important',
  },

  placementGradient: {
    display: 'block',
    height: '280px !important',
    top: 83,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
    fontSize: 10,
    lineHeight: '16px',
    color: '#bebebe',
  },

  placementShortHeadline: {
    width: 280,
    height: 54,
    fontSize: 20,
    fontWeight: 200,
    lineHeight: 1.3,
    color: 'white',
    paddingBottom: 5,

    '& .multi-line-processed-text': {
      position: 'absolute',
      bottom: 30,
    },
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      border: '.5px solid hsla(0,0%,100%,.3) !important',
      color: '#fff !important',
      opacity: 0.7,
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },
});
